// src/components/shared/modals/InfoModal.tsx
// Modal for displaying informational content (replaces browser alert() for info)
import type { ReactNode } from 'react';
import { Info } from 'lucide-react';
import BaseModal from './BaseModal';
import { Button } from '../../ui';

export interface InfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  closeText?: string;
}

const InfoModal = ({
  isOpen,
  onClose,
  title = 'Information',
  children,
  closeText = 'Close',
}: InfoModalProps) => {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      icon={{ Component: Info, bgColor: 'bg-blue-100', color: 'text-blue-600' }}
      maxWidth="max-w-lg"
      className="max-h-[80vh] flex flex-col"
    >
      <div className="p-6 overflow-y-auto flex-1">{children}</div>

      <div className="px-6 py-4 border-t border-line-soft flex justify-end flex-shrink-0">
        <Button type="button" onClick={onClose}>
          {closeText}
        </Button>
      </div>
    </BaseModal>
  );
};

export default InfoModal;
